export const checkScroll = ({ switchAt }) => {
  let atTop = true;

  if (window.scrollY > switchAt) {
    document.documentElement.classList.add("not-at-top");
    document.documentElement.classList.remove("at-top");
    atTop = false;
  } else {
    document.documentElement.classList.remove("not-at-top");
    document.documentElement.classList.add("at-top");
  }

  return atTop;
};

export const stickyHeader = () => {
  const header = document.querySelector(".header");
  if (!header) return;
  if (window.scrollY > 0) {
    header.classList.add("is-sticky");
  } else {
    header.classList.remove("is-sticky");
  }
};

export const scrollToAnchorOnClick = (selector) => {
  document.querySelectorAll(selector).forEach((btn) => {
    btn.addEventListener("click", function (e) {
      const href = btn.getAttribute("href");
      if (href && href.startsWith("#")) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });
};

export const scrollListener = ({ switchAt = 0 }) => {
  console.log("Initialize scrollListener");
  checkScroll({ switchAt });

  document.addEventListener("scroll", function (e) {
    checkScroll({ switchAt });
    stickyHeader();
  });
};
